import { SUBDOMAIN } from "../../../assets/meta/meta";
import { API } from "../../../api";

export const HECTO_API_URL =
  SUBDOMAIN === "test" ? "https://tbnpg.settlebank.co.kr" : "https://npg.settlebank.co.kr";

type HectoPayParamsArgs = {
  orderId: string;
  amount: number;
  phone: string;
  user_id: string;
  email?: string;
  username?: string;
  taxFreeAmt?: number;
  taxAmt?: number;
  vatAmt?: number;
};

export async function getHectoPayParams({
  orderId,
  amount,
  phone,
  user_id,
  email = "",
  username = "",
  taxFreeAmt = 0,
  taxAmt = 0,
  vatAmt = 0,
}: HectoPayParamsArgs): Promise<Record<string, any>> {
  const curr_date = new Date();
  const year = curr_date.getFullYear().toString();
  const month = ("0" + (curr_date.getMonth() + 1)).slice(-2).toString();
  const day = ("0" + curr_date.getDate()).slice(-2).toString();
  const hours = ("0" + curr_date.getHours()).slice(-2).toString();
  const mins = ("0" + curr_date.getMinutes()).slice(-2).toString();
  const secs = ("0" + curr_date.getSeconds()).slice(-2).toString();

  const trdDt = year + month + day;
  const trdTm = hours + mins + secs;

  const body: Record<string, string> = {
    trdDt,
    trdTm,
    subdomain: SUBDOMAIN,
    method: "card",
    mchtTrdNo: orderId,
    plainTrdAmt: String(amount),
    plainMchtCustId: user_id,
    plainCphoneNo: phone,
  };

  if (username) body.plainMchtCustNm = username;
  if (email) body.plainEmail = email;
  if (taxFreeAmt) body.plainTaxFreeAmt = String(taxFreeAmt);
  if (taxAmt) body.plainTaxAmt = String(taxAmt);
  if (vatAmt) body.plainVatAmt = String(vatAmt);

  const formData = new FormData();
  for (const key in body) {
    formData.append(key, body[key]);
  }

  const result = await API.post("/accounts/hecto-encryptparams/", formData);
  const pktHash = result.data.pktHash || result.data.hashCipher || "";

  return {
    ...result.data.encParams,
    pktHash,
    hashCipher: result.data.hashCipher,
    mchtId: result.data.mchtId,
    method: "card",
    mchtTrdNo: orderId,
    trdDt,
    trdTm,
  };
}

export function requestPaymentHecto(args: Record<string, any>): void {
  const SETTLE_PG = (globalThis as any).SETTLE_PG;
  if (!SETTLE_PG && !(window as any).SETTLE_PG) {
    throw new Error("SETTLE_PG is not defined");
  }

  if (!(window as any).SETTLE_PG) (window as any).SETTLE_PG = SETTLE_PG;
  const { pktHash: argPktHash, hashCipher, ui, ...restArgs } = args;
  const pktHash = argPktHash || hashCipher;
  if (!pktHash) {
    throw new Error("Hecto pktHash missing");
  }

  const payload = {
    env: HECTO_API_URL,
    mchtParam: SUBDOMAIN,
    ...restArgs,
    pktHash,
    ui: {
      type: "self",
      ...(ui || {}),
    },
  };

  (window as any).SETTLE_PG.pay(
    payload,
    function (rsp: any) {
      console.log(rsp);
    }
  );
}
